export default __webpack_public_path__ + "static/media/phone.f8dcc256.png";